<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title py-2 px-2 pb-0 mb-0">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
          <label class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'w-fit d-inline-block mr-2'" [ngClass.md]="'w-fit d-inline-block mr-2'" [ngClass.sm]="'d-none'">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a (click)="modalOpen(categoryAdd, null, 'add')" class="btn btn-outline-primary text-primary" *ngIf="_authenticationService.hasCapability('ticket_category_create')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 50 : 170"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="categoryList()"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true" width="400" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span [ngbTooltip]="row.description && row.description.length > 0 ? row.description : null">{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'MENU.ROLES' | translate }}" prop="name" width="500" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <span class="badge badge-secondary mr-025" *ngFor="let role of row.roles">{{ role.name }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" width="100" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button (click)="modalOpen(categoryEdit, row, 'edit')" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('ticket_category_edit')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteCategory(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('ticket_category_delete')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [width]="null" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12" [ngClass.md]="'pl-0'">
                  <span>{{ row.name }}</span>
                </div>
                <div class="col-12" [ngClass.md]="'pl-0'">
                  <span class="badge badge-secondary mr-025" *ngFor="let role of row.roles">{{ role.name }}</span>
                </div>
                <div class="col-12 mt-075 text-right" [ngClass.md]="'pr-1'">
                  <button (click)="modalOpen(categoryEdit, row, 'edit')" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('ticket_category_edit')">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button (click)="deleteCategory(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('ticket_category_delete')">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal Add -->
<ng-template #categoryAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "CATEGORY" | translate }}</h3>
    <div class="form-group">
      <label [for]="'new_category'">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
      <input [(ngModel)]="new_category" name="new_category" type="text" [id]="'new_category'" class="form-control" />
      <div class="font-error" *ngIf="showModalErrors && (!new_category || new_category.length < 1)">{{ "ERRORS.FIELD_NAME" | translate }}</div>
    </div>
    <div class="form-group">
      <label for="roles">{{ "MENU.ROLES" | translate }}<sup class="text-danger">*</sup></label>
      <ng-select id="roles" [(ngModel)]="addRoles" [searchable]="true" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [multiple]="true">
        <ng-option *ngFor="let role of _roleService.list" [value]="role.id">
          <span class="font-small-4 font-weight-normal">{{ role.name }}</span>
        </ng-option>
      </ng-select>
      <div class="font-error" *ngIf="showModalErrors && (!addRoles || addRoles < 1)">{{ "ERRORS.FIELD_LIST_ROLES" | translate }}</div>
    </div>
    <div class="form-group">
      <label [for]="'description'">{{ "DESCRIPTION" | translate }}</label>
      <textarea name="description" id="description" class="form-control" [maxlength]="255" [(ngModel)]="new_description"></textarea>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="addCategory()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Add -->

<!-- Modal Edit -->
<ng-template #categoryEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "CATEGORY" | translate }}</h3>
    <div class="form-group">
      <label [for]="'category'">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
      <input name="currentCategoryName" [(ngModel)]="currentCategory.name" type="text" [id]="'category'" class="form-control" />
      <div class="font-error" *ngIf="showModalErrors && (!currentCategory.name || currentCategory.name.length < 1)">{{ "ERRORS.FIELD_LIST_ROLES" | translate }}</div>
    </div>
    <div class="form-group">
      <label for="newRoles">{{ "MENU.ROLES" | translate }}<sup class="text-danger">*</sup></label>
      <ng-select id="newRoles" [(ngModel)]="addRoles" [searchable]="true" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [multiple]="true">
        <ng-option *ngFor="let role of this._roleService.list" [value]="role.id">
          <span class="font-small-4 font-weight-normal">{{ role.name }}</span>
        </ng-option>
      </ng-select>
      <div class="font-error" *ngIf="showModalErrors && (!addRoles || addRoles < 1)">{{ "ERRORS.FIELD_LIST_ROLES" | translate }}</div>
    </div>
    <div class="form-group">
      <label [for]="'currentDescription'">{{ "DESCRIPTION" | translate }}</label>
      <textarea name="currentDescription" id="currentDescription" class="form-control" [maxlength]="255" [(ngModel)]="currentCategory.description"></textarea>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="editCategory()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->
